// Local placeholder imagery for Greenbless.
// These are custom illustrations standing in for real product photography —
// swap them out for real photos of your produce, plants, and tools whenever
// you have them; nothing else in the app needs to change to do that.

import compostImage from "../assets/illustrations/product-compost.svg";
import crateImage from "../assets/illustrations/product-crate.jpg";
import seedpackImage from "../assets/illustrations/product-seedpack.webp";
import toolsImage from "../assets/illustrations/product-tools.jfif";
import plantImage from "../assets/illustrations/product-plant.jpg";

import heroProduce from "../assets/illustrations/hero-produce.jpg";
import heroSeeds from "../assets/illustrations/hero-seeds.jfif";
import heroTools from "../assets/illustrations/hero-tools.jpg";

// Default product image carousel (used when a product/category has no
// dedicated imagery of its own yet).
export const LOCAL_MAIN_IMAGE = crateImage;

export const LOCAL_CAROUSEL_IMAGES = [
  crateImage,
  compostImage,
  seedpackImage,
  plantImage,
];

// Category-specific carousels, keyed by the real Greenbless category slugs
// (see Schemas/supabase_schema.sql + Schemas/add_greenbless_categories.sql).
export const PRODUCE_CAROUSEL_IMAGES = [crateImage, plantImage, compostImage, seedpackImage];
export const SEEDS_CAROUSEL_IMAGES = [seedpackImage, plantImage, crateImage, compostImage];
export const TOOLS_CAROUSEL_IMAGES = [toolsImage, compostImage, crateImage, plantImage];

export const CATEGORY_HERO_IMAGES = {
  "fresh-produce": PRODUCE_CAROUSEL_IMAGES,
  "seeds-plants": SEEDS_CAROUSEL_IMAGES,
  "garden-tools": TOOLS_CAROUSEL_IMAGES,
};

// Homepage hero banners (full-bleed background slides).
export const HERO_PRODUCE_IMAGE = heroProduce;
export const HERO_SEEDS_IMAGE = heroSeeds;
export const HERO_TOOLS_IMAGE = heroTools;

// Generic product grid thumbnails used on the homepage.
export const LOCAL_PRODUCT_GRID_IMAGES = [
  crateImage,
  compostImage,
  seedpackImage,
  toolsImage,
  plantImage,
];
